import { axiosInstance } from './axios.service'
import { IResponse } from '../types/response.type'
import { ITiersResponse } from '../../shared/types/api/tier.type'
import { TierEndpoints } from '../types/endpoint.type'

export const getAllTiers = async (): Promise<IResponse<ITiersResponse>> => {
  try {
    const resp = await axiosInstance.get(TierEndpoints.GET_ALL)

    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
